import React, { useState,useEffect } from 'react';
import { useTheme } from "../ThemeContext";
import { Alert, Button, Form, Container, Row, Col } from 'react-bootstrap';
import { FaThumbsUp, FaThumbsDown, FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Import arrow icons
import FeatureRequestsList from './FeatureRequestsList';


const FeatureRequestBoard = () => {
 

  return (
    

      <div>
        <FeatureRequestsList />
      </div>
  
  );
};


export default FeatureRequestBoard;
